var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.223,
    height: 13.181,
    viewBox: "0 0 16.223 13.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter_1_",
    "data-name": "twitter (1)",
    d: "M16.223,49.56a6.934,6.934,0,0,1-1.916.525,3.307,3.307,0,0,0,1.463-1.838,6.646,6.646,0,0,1-2.109.805,3.326,3.326,0,0,0-5.753,2.274,3.425,3.425,0,0,0,.077.758,9.414,9.414,0,0,1-6.855-3.479,3.327,3.327,0,0,0,1.022,4.445,3.285,3.285,0,0,1-1.5-.41v.036a3.341,3.341,0,0,0,2.665,3.268,3.319,3.319,0,0,1-.872.11A2.941,2.941,0,0,1,1.812,56,3.357,3.357,0,0,0,4.92,58.316,6.683,6.683,0,0,1,.8,59.734a6.229,6.229,0,0,1-.8-.046,9.363,9.363,0,0,0,5.1,1.492,9.4,9.4,0,0,0,9.466-9.464c0-.147-.005-.289-.012-.43A6.635,6.635,0,0,0,16.223,49.56Z",
    transform: "translate(0 -48)",
    fill: "#040505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.986b7e97999d68b1396baa82b6f3f7e9.svg";
export { ForwardRef as ReactComponent };